<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <v-snackbar
      v-model="oldVersion"
      :color="snackbar.color"
      top
      :timeout="snackbar.timeout"
      >

      <v-row align="center">
        <v-col class="py-0 grow">
          <v-icon color="white" class="mx-3">{{ snackbar.icon}}</v-icon>
          <span class="white--text">{{ snackbar.text}}</span>
        </v-col>
        <v-col class="py-0 shrink">
          <v-btn
            color="white"
            outlined
            @click="refreshBrowser()"
            target="_blank"
            >
            Refresh browser
          </v-btn>
        </v-col>
      </v-row>
    </v-snackbar>

  <section id="page-wrapper">
      <section v-if="navigation" id="menu-wrapper" :class="{ 'menu-expanded' : $store.state.menuOpen }">
        <side-menu></side-menu>
      </section>

      <section :id="contentWrapperId" :class="{ 'menu-expanded' : $store.state.menuOpen }">
        <v-toolbar v-if="navigation" class="header-toolbar" :class="{ 'menu-expanded' : $store.state.menuOpen }" :color="companyPrimaryColor" fixed dark dense>
          <v-toolbar-title class="white--text">{{ $route.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <span class="white--text">{{ $store.state.version }}</span>
        </v-toolbar>

        <section :id="contentId">
          
          <router-view class="router-view" :key="$route.fullPath"/>
        </section>
      </section>
      
  </section>
  
  </v-app>

</template>

<script>
import Vue from "vue";

export default {
  name: "App",
  data() {
    return {
      loading: true,
      navigation: false,
      contentWrapperId: "content-wrapper-full",
      contentId: "content-full",
      snackbar: {
        text: "Nieuwe versie beschikbaar.",
        icon: "cached",
        timeout: -1,
        color: "info",
      },    
    };
  },

  created(){   
   
  },


  watch: {
    // call again the method if the route changes
    '$route': 'showNavigation'
  },
  
  methods: {
    refreshBrowser(){
      window.localStorage.setItem('pillarrrversion', this.$store.state.version);
      location.reload()
    },
    showNavigation(){
      if(this.$route.path != '/login' && this.$route.path != '/response' && this.$route.path != '/unsubscribe' ){
        this.navigation =  true;
        this.contentWrapperId = "content-wrapper";
        this.contentId = "content";
      }
      else {
        this.navigation =  false;
        this.contentWrapperId = "content-wrapper-full";
        this.contentId = "content-full";
      }
    },
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light';
    },
    oldVersion(){
      if(this.$store.state.version){
        if(window.localStorage.getItem('pillarrrversion')){
          if(window.localStorage.getItem('pillarrrversion') != this.$store.state.version){
            return true;
            console.log("Let op! dit is een andere versie: ", window.localStorage.getItem('pillarrrversion'), this.$store.state.version);
          }
        } 
        else {
          return false;
          window.localStorage.setItem('pillarrrversion', this.$store.state.version);
        }
      } 
      else{
         return false;
      }
    }
  }
};
</script>


<style>
.no-scroll{
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.no-scroll::-webkit-scrollbar {
  display: none;
}

h1.tab-title{
  padding: 10px 0;
  font-size: 24px;
  font-weight: bold;
}
.hogans-alerts .v-alert {
  margin: 0;
}
.v-dialog.v-dialog--active {
  border-radius: 20px;
}

.v-dialog.v-dialog--active .v-card.no-border {
  border-radius: 0;
}

.select-language-flag {
  float: left;
  margin: 20px 15px 0 0;
}

.select-language-input {
  float: left;
  width: 250px;
}

.language-flag {
  width: 30px;
  height: 20px;
  background-color: #f1f1f1;
}
.language-flag.nl {
  background: url("./assets/flags/dutch-flag.png") no-repeat center center;
  background-size: 30px 20px;
}

.language-flag.uk {
  background: url("./assets/flags/uk-flag.png") no-repeat center center;
  background-size: 30px 20px;
}

.question-wrapper {
  width: 100%;
}

.language-flag-wrapper {
  float: left;
  width: 25px;
  margin: 10px 10px 0 0;
}

.questionfield-wrapper {
  float: left;
  width: calc(100% - 40px);
}

.question-language-flag.nl {
  margin: 24px 0 0 0;
  width: 25px;
  height: 17px;
  background: #f1f1f1 url("./assets/flags/dutch-flag.png") no-repeat center center;
  background-size: 25px 17px;
}

.question-language-flag.en {
  margin: 24px 0 0 0;
  width: 25px;
  height: 17px;
  background: #f1f1f1 url("./assets/flags/uk-flag.png") no-repeat center center;
  background-size: 25px 17px;
}

.image-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;
  background: url("./assets/icons/image-loader.svg") no-repeat center center;
  background-size: 50px auto;
}

.blackbox-loader{
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -40px 0 0 -40px;
  width: 80px;
  height: 80px;
  border-radius: 5px;
  background: rgba(0,0,0, .5) url("./assets/blackbox-loader.svg") no-repeat center center;
  background-size: 45px auto;
}

.modal-loader{
  position: relative;
  margin: 0 5px;
  width: 30px;
  height: 30px;
  background: url("./assets/blackbox-loader.svg") no-repeat center center;
  background-size: 30px auto;
}




/* MODAL*/

.hogans-modal-header-close {
  position: absolute;
  background: url("./assets/icons/close-icon-white.svg") no-repeat center center;
  background-size: 16px;
  width: 20px;
  height: 20px;
  right: 20px;
  top: 50%;
  margin: -10px 0 0 0;
}

.hogans-modal-header-close:hover {
  cursor: pointer;
}

.hogans-modal-footer {
  padding: 10px;
  width: 100%;
}

.modal-button-next {
  display: inline-block;
  float: right;
  text-transform: none;
  font-size: 14px;
  font-weight: 00;
  height: 44px;
  line-height: 44px;
  color: #fff;
  font-weight: 600;
  border-radius: 60px;
  background-color: #e5007d;
  /* background: #e5007d url("./assets/icons/next-button-white.svg") no-repeat center right 4px; */
}

/* .modal-button-next:hover {
  background: #fff url("./assets/icons/next-button-pink.svg") no-repeat center right 4px;
  color: #e5007d;
  box-shadow: 0 8px 21px 0 rgba(229, 0, 125, 0.3);
  cursor: pointer;
} */

.modal-button-cancel {
  display: inline-block;
  float: left;

  text-transform: none;
  /* padding: 14px 15px; */
  height: 44px;
  font-size: 14px;
  /* line-height: 12px;
  color: #8b93a6;
  font-weight: 600;*/
  border-radius: 5px;
  border: 2px solid #e8e9ee !important;
  /*margin: 0 15px 0 0; */
}

/* .modal-button-cancel:hover {
  background: #ffffff;
  background-image: linear-gradient(-240deg, invalid gradient);
  box-shadow: 0 8px 21px 0 rgba(229, 0, 125, 0.3);
  border: none;
  padding: 16px 17px;
  color: #e5007d;
  cursor: pointer;
} */

.loading-dots {
  margin: 150px auto 0 auto;
  width: 350px;
  min-height: 80px;
}

.loading-dots-loader {
  margin: 150px auto 0 auto;
  width: 80px;
  height: 80px;
  background: url("./assets/icons/loading-dots.svg") no-repeat center center;
  background-size: 80px auto;
}

p.loading-dots-text {
  display: block;
  font-family: "Sofia Pro", sans-serif;
  font-size: 14px;
  color: #251433;
  width: 100%;
  padding: 5px 0;
  text-align: center;
}

.pillar-log-table {
  background-color: #fff;
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
}
.pillar-log-table td{
  font-size: 12px!important;
}

.extra-loading-dots {
  margin: 20px auto 0 auto;
  width: 60px;
  height: 60px;
  background: url("./assets/icons/loading-dots.svg") no-repeat center center;
  background-size: 60px auto;
}
body {
  width: 100%;
  position: relative;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f6f7fb;
}

input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}

.application--wrap {
  background-color: #f6f7fb;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
a,
input,
select,
label,
div {
  font-family: "Sofia Pro", sans-serif;
  color: var(--v-text-base);
  font-weight: 400;
  margin: 0;
  -webkit-font-smoothing: antialiased;
}

a,
div,
span,
input,
textarea,
select:focus {
  outline: none;
}

h2 {
  font-size: 22px;
}

.clear::after {
  display: block;
  content: "";
  clear: both;
}

.menu-item:hover {
  cursor: pointer;
}

#page-wrapper {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

/* SIDEBAR MENU */

.main-menu {
  width: 52px;
  margin: 100px 0 0 12px;
  padding: 0;
}

.main-menu li {
  list-style: none;
  margin: 0;
  padding: 15px 0;
}

.menu-item.router-link-active .v-icon,
.menu-item.router-link-active .v-list__tile__title {
  color: #000000 !important;
}

.main-menu li a {
  display: block;
  width: 52px;
  height: 52px;
  border-radius: 100px;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.header-toolbar {
  position: fixed!important;
  top: 0;
  z-index: 9!important;;
  left: 70px!important;;
  width: calc(100% - 70px)!important;;
  left: 0;
  width: 100%;
}

.header-toolbar.menu-expanded {
  left: 0;
  left: 275px!important;;
  width: calc(100% - 275px)!important;;
  width: 100%;
}

#header-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  /* left: 70px; */
  /* width: calc(100% - 70px); */
  width: 100%;
  background-color: var(--v-menu-base);
  border-bottom: 1px solid var(--v-menuborder-base);
}

#menu-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  overflow: hidden; 
  width: 70px;
  height: 100%;
  border-right: 1px solid var(--v-menuborder-base);
  background-color: rgba(0,0,0,0.01);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

#menu-wrapper::-webkit-scrollbar {
    display: none;
}

#menu-wrapper.menu-expanded {
  width: 275px;
}

#page-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
}

.custom-select-hogans.float {
  float: left;
}

.custom-select-hogans.medium {
  width: 380px;
}

.custom-select-hogans.small {
  width: 280px;
}

.custom-select-hogans:hover > .custom-select-hogans-items-wrapper {
  display: block;
}

.custom-select-hogans:hover > .custom-select-hogans-value {
  border-color: #4a148c;
}

.custom-select-hogans-arrow {
  position: absolute;
  margin-top: 22px;
  right: 20px;
  border: 6px solid #8b93a6;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}

.custom-select-hogans-value {
  width: calc(100% - 30px);
  height: 44px;
  line-height: 48px;
  font-size: 18px;
  color: #4a148c;
  padding: 0 15px;
  border: 2px solid #e8e9ee;
  border-radius: 50px;
  background-color: #fff;
}
.custom-select-hogans-items-wrapper {
  display: none;
  max-height: 350px;
  background-color: #ffffff;
  box-shadow: 0 7px 12px 0 rgba(139, 147, 166, 0.28);
  border-radius: 5px;
  position: absolute;
  width: 100%;
  top: 40px;
  left: 25px;
  overflow-y: scroll;
  cursor: pointer;
  z-index: 999;
}

.custom-select-hogans-item {
  display: block;
  width: calc(100% - 20px);
  color: #8b93a6;
  font-size: 14px;
  padding: 15px 10px;
  cursor: pointer;
}

.custom-select-hogans-item:hover {
  background-color: #4a148c;
  color: #fff;
  cursor: pointer;
}

.table-color-preview {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  border: 1px solid #ccc;
}
.custom-form-label {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.55);
  margin: 0;
}
/* AMDIN MENU */

.admin-menu-add {
  display: block;
  float: right;
  margin: 0 0 0 15px;
  width: 50px;
  position: relative;
}

.admin-menu-item-wrapper {
  display: none;
  position: absolute;
  width: 170px;
  top: 30px;
  right: 30px;
  z-index: 99;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 7px 12px 0 rgba(139, 147, 166, 0.28);
}

.admin-menu-add:hover > .admin-menu-item-wrapper {
  display: block;
}

.admin-menu-item {
  display: block;
  color: #8b93a6;
  font-size: 14px;
  padding: 10px;
  text-decoration: none;
}

.admin-menu-add:hover {
  cursor: pointer;
}

.admin-menu-item:hover {
  cursor: pointer;
  background-color: #4a148c;
  color: #fff;
}

#content-wrapper {
  position: absolute;
  left: 70px;
  top: 0;
  height: 100%;
  width: calc(100% - 70px);
  overflow: hidden;
}

#content-wrapper.menu-expanded {
  left: 275px;
  width: calc(100% - 275px);
}

#content {
  position: absolute;
  left: 0px;
  top: 0;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 65px 15px 15px 15px;
  overflow-y: scroll;
}

#content.pricelist {
  padding: 60px 0px 25px 0px;
}

.content-header {
  width: 100%;
  height: 65px;
}

.content-header-extra {
  width: 100%;
}

.header-select {
  width: 50%;
  float: left;
}

.header-select-select {
  float: left;
  margin: 0 20px 0 0;
}

.header-select-button {
  width: auto;
  float: left;
  margin: 0;
}

.content-header-extra .header-title {
  float: none;
}

.content-header-extra .header-edit {
  float: right;
}

.content-header-extra .header-content {
  margin: 15px 0;
}

.content-header.border {
  border-bottom: 1px solid #e8e9ee;
}

.sub-header h3 {
  float: left;
  margin: 0 20px 0 0;
}

.sub-header.border {
  border-bottom: 1px solid #e8e9ee;
}

.header-title {
  width: 50%;
  float: left;
}

.header-title h1 {
  margin: 0;
  padding: 0;
  font-size: 30px;
}

.header-edit {
  width: 50%;
  float: left;
}
.header-edit-search {
  float: right;
  width: 250px;
  margin: 0 0 0 10px;
}

.header-edit-button {
  float: right;
  width: auto;
  margin: 0 0 0 20px;
}

.client-info-button {
  margin: 0;
  background-color: #bfc5d2;
  color: #fff;
  border: none;
  padding: 5px 10px;
  /* border-radius: 20px; */
}

@media only screen and (max-width: 1024px) {
  #content {
    padding: 65px 15px 15px 15px;
  }

  #content.pricelist {
    padding: 60px 0px 15px 0px;
  }

  .content-header-extra.journey .header-content {
    margin: 0;
  }
}

.client-info-button:hover {
  cursor: pointer;
  background-color: #4a148c;
}

.question-list-item-wrapper.header {
  background: none;
  margin: 15px 0 0 0;
}

.question-list-item-wrapper.header .question-list-item {
  color: #8b93a6;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
}

.question-list-item span.order {
  margin: 16px 5px;
  height: 4px;
  border: 5px solid #8b93a6;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  position: absolute;
}

.question-list-item span.order.desc {
  margin: 8px 5px;
  height: 4px;
  border: 5px solid #8b93a6;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: transparent;
  position: absolute;
}

.question-list-item-wrapper {
  background-color: #ffffff;
  border-radius: 5px;
  margin: 12px 0;
  padding: 0;
  color: #251433;
  font-family: "Sofia Pro", sans-serif;
  font-size: 16px;
  font-weight: 300;
  position: relative;
  z-index: 9;
}

.question-list-item-wrapper:hover {
  z-index: 1;
  box-shadow: 0 6px 60px 0 rgba(95, 29, 154, 0.2);
  cursor: pointer;
}

.question-list-item-wrapper.header:hover {
  box-shadow: none;
}

.question-list-item {
  height: 54px;
  line-height: 78px;
  text-align: center;
  position: relative;
}

.question-list-item.active {
  position: relative;
  width: 14px;
  margin: 0 auto;
}

.question-color {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px 0 0 -10px;
}

.color-code {
  margin: 10px 0 0 0;
}

.circle {
  border: 3px solid #f94500;
  width: 12px;
  height: 12px;
  border-radius: 15px;
  position: absolute;
  margin: -5px 0 0 -5px;
  top: 50%;
  left: 50%;
}

.question-list-item.active.true .circle {
  border-color: #73db02;
}

#survey-results {
  width: 100%;
}

.compare-button {
  display: block;
  float: right;
  padding: 13px 50px 13px 20px;
  text-decoration: none;
  font-weight: 600;
  position: relative;
  z-index: 1;
  color: #fff;
  border: 2px solid #e8e9ee;
  line-height: 16px;
  text-transform: uppercase;
}
/* .compare-button.left.passive,
.compare-button.right.passive */

/* .compare-button:hover,
.compare-button.left:hover,
.compare-button.right:hover {
  color: #fff;
  box-shadow: 0 8px 21px 0 rgba(95, 29, 154, 0.3);
  border-color: #4a148c;
  background-color: #4a148c;
  z-index: 9;
  cursor: pointer;
}
 */


/* .compare-button.left {
  padding: 13px 20px 13px 20px;
  border-right: none;
  background-color: #f6f7fb;
  background-size: 20px;
  border-radius: 5px 0 0 5px;
} */

.compare-button.single{
  width: 140px;
  border-radius: 5px 0 0 5px;
}

.compare-button.single.passive {
  border-left: none;
  background-color: #f6f7fb!important;
  background-image: url("./assets/icons/single-mode-icon.svg");
  background-repeat: no-repeat;
  background-position: center right 15px;
  background-size: 20px;
  color: #b4bbc9!important;
  border-top: 2px solid #e8e9ee!important;
  border-bottom: 2px solid #e8e9ee!important;
  border-right: none!important;
  border-left: 2px solid #e8e9ee!important;
}

.compare-button.dual{
  border-radius: 0 5px 5px 0;
}

.compare-button.dual.passive {
  border-left: none;
  background-color: #f6f7fb!important;
  background-image: url("./assets/icons/dual-mode-icon.svg");
  background-repeat: no-repeat;
  background-position: center right 15px;
  background-size: 20px;
  color: #b4bbc9!important;
  border-top: 2px solid #e8e9ee!important;
  border-bottom: 2px solid #e8e9ee!important;
  border-left: none!important;
  border-right: 2px solid #e8e9ee!important;
}

.compare-button.dual:hover,
.compare-button.single:hover{
  cursor: pointer;
}

/* .compare-button.right {
  padding: 13px 20px 13px 20px;
  border-left: none;
  background-color: #f6f7fb;
  background-size: 20px;
  border-radius: 0 5px 5px 0;
} */

.compare-button.dual {
  background-image:url("./assets/icons/dual-mode-icon-active.svg");
  background-repeat: no-repeat;
  background-position: center right 15px;
  background-size: 20px;
}

.compare-button.single {
  background-image: url("./assets/icons/single-mode-icon-active.svg");
  background-repeat: no-repeat;
  background-position: center right 15px;
  background-size: 20px;
}

/* 
.compare-button.dual:hover {
  background-image: url("./assets/icons/dual-mode-icon-active.svg");
  background-repeat: no-repeat;
  background-position: center right 15px;
  background-size: 20px;
}

.compare-button.single:hover {
  background-image: url("./assets/icons/single-mode-icon-active.svg");
  background-repeat: no-repeat;
  background-position: center right 15px;
  background-size: 20px;
} */

#survey-results .resultsbox-wrapper.two {
  display: none;
}

#survey-results.dual .resultsbox-wrapper.two {
  display: block;
}

#survey-results.dual .resultsbox-wrapper.one,
#survey-results.dual .resultsbox-wrapper.two {
  width: 50%;
  float: left;
}

#survey-results.dual .resultsbox-wrapper.one .resultsbox-inner {
  padding: 0 35px 0 0;
}

#survey-results.dual .resultsbox-wrapper.two .resultsbox-inner {
  padding: 0 0 0 35px;
}

.results {
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #e8e9ee;
  margin: 0;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
}

.results.one.dual{
  width: calc(100% - 25px);
  margin: 0 25px 0 0;
  float: left;
}

.results.two.dual{
  width: calc(100% - 25px);
  margin: 0 0 0 25px;
  float: right;
}

.branches-wrapper {
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  padding: 0 0 15px 0;
  border: 1px solid #e8e9ee;
  margin: 25px 0 0 0;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
}

.branches-wrapper h3{
  line-height: 32px;
}

.branches-wrapper.one.dual{
  width: calc(100% - 25px);
  margin: 25px 25px 0 0;
  float: left;
}

.branches-wrapper.two.dual{
  width: calc(100% - 25px);
  margin: 25px 0 0 25px;
  float: right;
}

@media only screen and (max-width: 1024px) {
  .results {
    padding: 15px;
  }

  #survey-results.dual .resultsbox-wrapper.one .resultsbox-inner {
    padding: 0 15px 0 0;
  }

  #survey-results.dual .resultsbox-wrapper.two .resultsbox-inner {
    padding: 0 0 0 15px;
  }
}

.results-graph,
.filter-box {
  width: 100%;
}

.nv-x.nv-axis .tick {
  display: none;
}
.results-table-wrapper {
  height: 80px;
}

.results-table-wrapper h3 {
  font-size: 14px;
  color: #8b93a6;
  padding: 0 0 5px 0;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-family: "Sofia Pro", sans-serif;
  font-weight: 400;
  color: #8b93a6;
}

.results-table tr.header td {
  background-color: #f6f7fb;
  font-size: 10px;
}

.results-table tr td {
  background-color: #fff;
  border: 1px solid #e8e9ee;
  text-align: center;
  font-size: 16px;
  padding: 6px 0;
}

.results-filter-header,
.results-summary-header {
  width: 100%;
  padding: 0 0 10px 0;
  margin: 0 0 10px 0;
  border-bottom: 1px solid #e8e9ee;
}

.results-feedback-box-wrapper{
  padding: 10px 0 0 0;
}

.results-feedback-box-wrapper h2 {
  font-size: 18px;
}

.results-filter-header label {
  font-size: 14px;
  color: #8b93a6;
}

.date-filter {
  width: 60%;
  float: left;
}

.geslacht-filter {
  width: 40%;
  float: left;
}

.score-header {
  width: 35%;
  float: left;
}

.smile-header {
  width: 40%;
  float: left;
}

.people-header {
  width: 25%;
  float: left;
}

.results-summary-header p {
  font-size: 14px;
  color: #8b93a6;
}

.results-summary-header p.header-number {
  font-size: 26px;
  font-weight: 300;
  color: #00adef;
}

/* OVERLAY & SNACKBAR*/

.filter-select {
  float: left;
  margin: 0 20px 0 0;
}

.filter-select-item label {
  width: 110px;
  float: left;
  text-align: right;
  padding: 0 10px 0 0;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
}
.get-results-button {
  display: inline-block;
  float: left;
  text-decoration: none;
  padding: 14px 55px 14px 15px;
  height: 15px;
  line-height: 15px;
  color: #4a148c;
  font-weight: 600;
  border-radius: 60px;
  background: #ffffff url("./assets/icons/button-results.svg") no-repeat center right 4px;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.get-results-button:hover {
  background: #00adef url("./assets/icons/button-results-white.svg") no-repeat center right 4px;
  color: #fff;
}

.send-mail-button {
  display: inline-block;
  text-decoration: none;
  padding: 14px 55px 14px 15px;
  height: 44px;
  line-height: 44px;
  color: #ffffff;
  font-weight: 600;
  border-radius: 60px;
  background: #ffffff url("./assets/icons/button-send.svg") no-repeat center right 4px;
}

.send-mail-button:hover {
  background: #00adef url("./assets/icons/button-send-white.svg") no-repeat center right 4px;
  color: #ffffff;
}

.primary-button.next {
  display: inline-block;
  text-decoration: none;
  padding: 14px 55px 14px 15px;
  height: 44px;
  line-height: 14px;
  color: #fff;
  font-weight: 600;
  border-radius: 60px;
  background: #e5007d url("./assets/icons/next-button-white.svg") no-repeat center right 4px;
}

.primary-button.next:hover {
  background: #fff url("./assets/icons/next-button-pink.svg") no-repeat center right 4px;
  color: #e5007d;
  box-shadow: 0 2px 24px 0 rgba(139, 147, 166, 0.25);
  border-radius: 35px;
}

.model-form-buttons-wrapper {
  padding: 15px 0;
}

.model-form-buttons-left {
  float: left;
  width: 50%;
}

.model-form-buttons-right {
  float: right;
  width: 50%;
}

.model-form-buttons-right button {
  float: right;
}

.text-selected {
  color: #ffffff;
}

@media only screen and (max-width: 1690px) {
  .text-selected {
    display: none;
  }

  .selected-number {
    width: 35px;
    height: 35px;
    border-radius: 50px;
    line-height: 40px;
    font-size: 16px;
    margin: 5px 5px 0 15px;
  }

  .snackbar-one p,
  .snackbar-two p {
    margin: 0;
  }

  .get-results-button {
    display: inline-block;
    float: left;
    text-decoration: none;
    padding: 14px 15px 14px 15px;
    height: 15px;
    font-size: 12px;
    line-height: 15px;
    background: none;
    background-color: #fff;
  }

  .get-results-button:hover {
    color: #fff;
    background: none;
    background-color: #00adef;
  }
}

.content-box {
  background-color: #fff;
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
}

.content-box-email {
  background-color: #fff;
  border-radius: 5px;
  padding: 20px;
  margin: 30px 0 30px 0;
}

.content-box.border {
  border: 1px solid #e8e9ee;
}

.content-box h3 {
  font-size: 18px;
  padding: 15px 0;
  border-bottom: 1px solid #e8e9ee;
}

.content-box h3 span {
  color: #8b93a6;
  font-size: 14px;
  padding: 0 10px;
}

.smiley-score-wrapper {
  width: 148px;
  height: 33px;
  background-color: #ccc;
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;
}

.smiley-score-overlay {
  top: -1px;
  left: -1px;
  position: absolute;
  z-index: 1;
  background: url("./assets/smiley-frame.svg") no-repeat left top;
  height: 36px;
  width: 150px;
  background-size: 150px 36px;
}

.smiley-score-underlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 34px;
  border-right: none;
  background-color: #00adef;
  z-index: 0;
  width: 175px;
}

.footer-pager {
  padding: 30px 0 0 0;
}

.footer-page-number {
  border: 1px solid #e8e9ee;
  border-radius: 5px;
  float: left;
  overflow: hidden;
}

.footer-items-number {
  border: 1px solid #e8e9ee;
  border-radius: 5px;
  float: right;
  overflow: hidden;
}

.footer-page-item {
  width: 38px;
  height: 38px;
  line-height: 40px;
  text-align: center;
  float: left;
  color: #4a148c;
  font-size: 14px;
  background-color: #ffffff;
  border-right: 1px solid #e8e9ee;
}

.footer-page-item.pages {
  width: auto;
  padding: 0 10px;
}

.footer-page-item.pages:hover {
  cursor: default;
  background-color: #fff;
  color: #4a148c;
  border-right: 1px solid #e8e9ee;
}

.footer-number-item {
  width: 38px;
  height: 38px;
  line-height: 40px;
  text-align: center;
  float: left;
  color: #8b93a6;
  font-size: 14px;
  background-color: #ffffff;
  border-right: 1px solid #e8e9ee;
}

.footer-page-item:hover,
.footer-number-item:hover,
.footer-page-item.activated:hover,
.footer-number-item.activated:hover {
  cursor: pointer;
  background-color: #00adef;
  border-right: 1px solid #00adef;
  color: #fff;
}

.footer-page-item.activated,
.footer-number-item.activated {
  background-color: #4a148c;
  border-right: 1px solid #4a148c;
  color: #fff;
}

.footer-page-item.last,
.footer-number-item.last {
  border-right: none !important;
}

.footer-page-item.previous {
  background: #fff url("./assets/icons/pager-previous-grey.svg") no-repeat center center;
  background-size: 10px auto;
}

.footer-page-item.previous:hover {
  background: #00adef url("./assets/icons/pager-previous-white.svg") no-repeat center center;
  background-size: 10px auto;
}

.footer-page-item.next {
  background: #fff url("./assets/icons/pager-next-grey.svg") no-repeat center center;
  background-size: 10px auto;
}

.footer-page-item.next:hover {
  background: #00adef url("./assets/icons/pager-next-white.svg") no-repeat center center;
  background-size: 10px auto;
}

.approved-circle {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -6px 0 0 -6px;
  border: 3px solid #f94500;
  width: 6px;
  height: 6px;
  border-radius: 50px;
}

.approved-circle.true {
  border-color: #73db02;
}

md-toolbar.md-default-theme:not(.md-menu-toolbar),
md-toolbar:not(.md-menu-toolbar) {
  background-color: #4a148c !important;
  color: #ffffff !important;
}

.md-button.md-default-theme.md-primary.md-fab span,
.md-button.md-primary.md-fab span,
.md-button.md-default-theme.md-primary.md-raised span,
.md-button.md-primary.md-raised span,
.md-date-range-picker__calendar__selected span,
md-toolbar.md-default-theme:not(.md-menu-toolbar) span,
md-toolbar:not(.md-menu-toolbar) span {
  color: #ffffff !important;
}

.md-date-range-picker__calendar__selected {
  background-color: #4a148c !important;
  color: #fff !important;
}

.md-button.md-default-theme.md-primary.md-fab,
.md-button.md-primary.md-fab,
.md-button.md-default-theme.md-primary.md-raised,
.md-button.md-primary.md-raised {
  color: #ffffff !important;
  background-color: #00adef !important;
}

.data-no-results-wrapper {
  position: relative;
  width: 100%;
}

.data-no-results {
  padding: 100px 0 ;
}

.data-no-results-icon {
  margin: 0 auto;
  width: 180px;
  height: 180px;
  background-color: #e7e9ee; 
  border-radius: 100%;
}

.data-no-results-text {
  padding: 15px 0 0 0;
  font-size: 19px;
  color: #bfc5d2;
  text-align: center;
}

.log-table-wrapper {
  display: flex;
  justify-content: space-between;
}
.log-table-wrapper.header {
  border-bottom: 2px solid #e8e9ee;
}

.log-table-wrapper {
  padding: 20px 0;
  border-bottom: 1px solid #e8e9ee;
}

.log-table-wrapper.header .log-table-item {
  font-size: 16px;
}

.log-table-item.center {
  text-align: center;
}

.log-table-item {
  flex: 1;
  flex-wrap: wrap;
  color: #8b93a6;
  font-size: 14px;
  position: relative;
}

.log-table-item.big {
  flex: 2;
}

.log-table-item.bigger {
  flex: 3;
}

.table-items-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-left: 1px solid var(--v-menuborder-base);
}

.table-items-wrapper.header {
  border-top: 1px solid var(--v-menuborder-base);
}

.table-items-wrapper .table-item {
  flex: 1 100%;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  padding: 2px;
  border-bottom: 1px solid var(--v-menuborder-base);
  border-right: 1px solid var(--v-menuborder-base)
}

.table-items-wrapper.header .table-item {
  background-color: var(--v-menuborder-base);
  color: var(--v-text-base);
  flex: 1 100%;
}

.table-history {
  flex-flow: row wrap;
  margin: 10px 0 0 0;
  max-height: 130px;
  overflow-y: scroll;
  border: 1px solid #e8e9ee;
  padding: 10px;
}

.table-history tr.table-heading td,
.results-table-history tr.table-heading td {
  border-bottom: 2px solid #e8e9ee;
}

.table-history tr td,
.results-table-history tr td {
  color: #8b93a6;
  border-bottom: 1px solid #e8e9ee;
  padding: 5px;
  font-size: 14px;
}

.results-feedback-label {
  padding: 20px 0 10px 0;
  display: block;
  font-size: 14px;
  color: #8b93a6;
}

.results-feedback-wrapper-header {
  border: 1px solid #e8e9ee;
  border-bottom: none;
}

.results-feedback-wrapper-header .results-feedback-item {
  border: none;
}

.results-feedback-wrapper {
  border: 1px solid #e8e9ee;
  height: 200px;
  overflow-y: scroll;
  background-color: #f6f7fb;
}

.results-feedback,
.results-feedback-heading {
  display: flex;
}
.results-feedback-heading .results-feedback-item {
  background-color: #f6f7fb;
  font-weight: 600;
}

.results-feedback-item {
  flex: 1;
  flex-wrap: wrap;
  border-bottom: 1px solid #e8e9ee;
  padding: 7px 10px !important;
  font-size: 14px;
  color: #8b93a6;
  vertical-align: middle;
  background-color: #fff;
}

.results-feedback-item.one,
.results-feedback-item.two,
.results-feedback-item.three {
  flex-basis: 15%;
}

.results-feedback-item.four {
  flex-basis: 55%;
}

.customer-history-rating,
.customer-history-feedback {
  width: 100%;
  overflow-y: scroll;
  max-height: 350px;
  margin: 20px 0;
}

.customer-feedback-items,
.customer-feedback-header {
  display: flex;
  justify-content: space-between;
}

.customer-feedback-header .customer-feedback-item {
  font-weight: 600;
}

.customer-feedback-header .customer-feedback-item {
  border: none;
  border-bottom: 2px solid #e8e9ee;
  padding: 10px 10px 10px 0 !important;
}

.customer-feedback-item {
  flex: 1;
  flex-wrap: wrap;
  border: none;
  border-bottom: 1px solid #e8e9ee;
  padding: 22px 10px 22px 0 !important;
  font-size: 14px;
  color: #8b93a6;
}

.customer-feedback-item.three {
  flex: 2;
}

.customer-feedback-item.five {
  text-align: right;
}

.client-info-tabs {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 30px 0 0 0;
  border-bottom: 1px solid #00adef;
}

.client-info-item {
  padding: 10px 25px;
  background-color: #fff;
  border: 1px solid #e8e9ee;
  color: #8b93a6;
  position: relative;
  font-size: 16px;
  height: 20px;
  line-height: 22px;
  border-bottom: none;
}

.client-info-item:hover {
  background-color: #00adef;
  border-color: #00adef;
  cursor: pointer;
  color: #fff;
  box-shadow: 0 2px 6px 0 rgba(229, 0, 125, 0.3);
}

.client-info-item.active {
  background-color: #00adef;
  border-color: #00adef;
  color: #fff;
  box-shadow: 0 2px 6px 0 rgba(229, 0, 125, 0.3);
}

.client-info-item.first {
  border-top-left-radius: 5px;
  border-bottom: none;
  border-right: none;
}

.client-info-item.last {
  border-top-right-radius: 5px;
  border-bottom: none;
  border-left: none;
}

.client-info-tab-summary-wrapper {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px 0;
  justify-content: space-between;
  border-bottom: 2px solid #e8e9ee;
}

.client-info-tab-summary-item {
  border-left: 2px dashed #e8e9ee;
  padding: 0 20px;
}

.client-info-tab-summary-item.first {
  border-left: none;
  padding: 0 20px 0 0;
}

.client-info-tab-summary-item h3 {
  color: #8b93a6;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  padding: 0 0 10px 0;
  border: none;
}

.client-info-tab-summary-item p {
  color: #8b93a6;
  font-size: 14px;
  margin: 0;
  padding: 0 0 5px 0;
  border: none;
}

.permission-check {
  width: 40px;
}

.customer-history-type-select-wrapper {
  padding: 10px 0 0 0;
}
.customer-history-type-select-item {
  padding: 8px 15px;
  background-color: #fff;
  border: 1px solid #e8e9ee;
  color: #4a148c;
  float: left;
  position: relative;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
}

.customer-history-type-select-item:hover {
  cursor: pointer;
}

.customer-history-type-select-item.active {
  background-color: #4a148c;
  color: #fff;
  z-index: 9;
  box-shadow: 0 -1px 12px 0 rgba(139, 147, 166, 0.28);
}

.customer-history-type-select-item.one {
  border-top-left-radius: 5px;
  border-bottom: none;
  border-right: none;
}

.customer-history-type-select-item.two {
  border-top-right-radius: 5px;
  border-bottom: none;
  border-left: none;
}

/*
  <div class="question-colors">
	  <div class="question-color">
		  <h4>#1</h4>
			  <div class="question-color-select">
				  <color-picker event-api="eventApi" options="options" ng-model=""></color-picker>
				  <label>#</label>
				  <input type="text" value=""/>
			  </div>
	  </div>
  </div>

  */

.question-colors {
  display: flex;
  border-right: 1px solid #e8e9ee;
  width: 100%;
  padding: 0 0 20px 0;
}

.question-color-wrapper h4 {
  text-align: center;
  color: #251433;
  padding: 5px 0;
  font-size: 14px;
}

.question-color-wrapper {
  font-family: "Sofia Pro", sans-serif;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 5px;
}

.question-colorbutton-wrapper {
  font-family: "Sofia Pro", sans-serif;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 22px 10px;
  width: 133px;
}

.question-color-select .colorpicker {
  float: left;
  margin: 0 5px 0 0;
  width: 25px;
  height: 25px;
}

.question-color-select label {
  float: left;
  padding: 0 5px;
  height: 30px;
  line-height: 35px;
  color: #8b93a6;
}

.question-color-select input {
  background: #ffffff;
  border: 1px solid #e8e9ee;
  border-radius: 5px;
  padding: 10px 5px;
  font-size: 12px;
  height: 25px;
  color: #8b93a6;
  width: calc(100% - 35px);
  float: left;
}

.legenda p {
  display: inline-block;
  color: #8b93a6;
  font-size: 14px;
}

.legenda p span {
  display: inline-block;
  margin: 0 3px 0 10px;
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

.hide {
  display: none !important;
}

.dashboard-wrapper {
  display: flex;
}

.dashboard-item {
  margin: 0 20px 0 0;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-between;
}

.dashboard-item.last {
  margin: 0;
}

.dashboard-item.big {
  flex: 2;
}

/* NODE IMPORT FORM  */

.reviews-import {
  width: 500px;
}

.reviews-import label {
  display: block;
}

.reviews-import label,
.reviews-import input {
  width: 100%;
}

.reviews-import .form-group {
  padding: 5px 0;
}

.reviews-import input[type="submit"] {
  width: 50%;
  border: none;
  padding: 10px 0;
  background-color: #4a148c;
  color: #fff;
  font-size: 18px;
}

.reviews-import input[type="submit"]:hover {
  background-color: #e5007d;
  cursor: pointer;
}

/* RESPONSE PAGE */

.survey-wrapper {
  display: block;
  position: relative;
  width: 650px;
  padding: 20px 20px 10px 20px;
  margin: 80px auto 120px auto;
  background: #ffffff;
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
}

.survey-logo-client img {
  width: 100%;
  height: auto;
}

.survey-logo-client {
  width: 100px;
  height: 100px;
  display: block;
  margin: 30px auto;
  overflow: hidden;
}

.survey-wrapper h2 {
  font-size: 28px;
  color: #111111;
  text-align: center;
  font-family: "TT Norms", sans-serif;
  font-weight: 500;
  margin: 0;
  padding: 10px 0;
}

.survey-wrapper p {
  font-family: "TT Norms", sans-serif;
  color: #111111;
  text-align: center;
  padding: 10px 0;
  margin: 0;
  font-size: 16px;
}

.feedback-option{
  margin: -15px 0 0 0;
}

.feedback-option-label{
  font-size: 16px;
  color: #111111;
  text-align: left;
  font-family: "TT Norms", sans-serif;
  font-weight: 500;
  margin: 0 0 10px 0;
}

/* footer */
.survey-footer p {
  font-size: 12px;
  color: #111111;
}

.feedback-wrapper {
  padding: 20px 0 50px 0;
}

.survey-item {
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  padding: 10px 10px 0 10px;
  margin: 20px 0;
}

.survey-wrapper .survey-item h2 {
  font-size: 20px;
  padding: 5px 0 10px 0;
}

.survey-item textarea {
  width: 100%;
  padding: 10px;
  height: 80px;
  border: none;
  background: #f6f7fb;
  font-family: "Sofia Pro", sans-serif;
  font-size: 16px;
  color: #333;
  resize: none !important;
}

.survey-item.feedback {
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  padding: 10px 15px;
  margin: 20px 0;
}

.survey-item .input-group {
  padding: 0;
}

.survey-item .v-input {
  margin: 0;
}

.survey-item .input-group__details {
  display: none;
}

.survey-item .v-input--radio-group__input {
  display: block;
}

.icon-wrapper {
  padding: 0;
}

.v-input--selection-controls.v-input .rating-icon label.v-label {
  background-size: 105px !important;
}

.v-input--selection-controls.v-input .rating-icon.rating-super label.v-label {
  background: url("./assets/icons/rating/rating-icon-super.png") no-repeat center center;
}

.v-input--selection-controls.v-input .rating-icon.rating-goed label.v-label {
  background: url("./assets/icons/rating/rating-icon-goed.png") no-repeat center center;
}
.v-input--selection-controls.v-input .rating-icon.rating-voldoende label.v-label {
  background: url("./assets/icons/rating/rating-icon-voldoende.png") no-repeat center center;
}

.v-input--selection-controls.v-input .rating-icon.rating-onvoldoende label.v-label {
  background: url("./assets/icons/rating/rating-icon-onvoldoende.png") no-repeat center center;
}

.v-input--selection-controls.v-input .rating-icon.rating-slecht label.v-label {
  background: url("./assets/icons/rating/rating-icon-slecht.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-super label.v-label {
  background: url("./assets/icons/rating/rating-icon-super-inactive.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-goed label.v-label {
  background: url("./assets/icons/rating/rating-icon-goed-inactive.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-voldoende label.v-label {
  background: url("./assets/icons/rating/rating-icon-voldoende-inactive.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-onvoldoende label.v-label {
  background: url("./assets/icons/rating/rating-icon-onvoldoende-inactive.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-slecht label.v-label {
  background: url("./assets/icons/rating/rating-icon-slecht-inactive.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-super.rating-5 label.v-label {
  background: url("./assets/icons/rating/rating-icon-super-active.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-goed.rating-4 label.v-label {
  background: url("./assets/icons/rating/rating-icon-goed-active.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-voldoende.rating-3 label.v-label {
  background: url("./assets/icons/rating/rating-icon-voldoende-active.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-onvoldoende.rating-2 label.v-label {
  background: url("./assets/icons/rating/rating-icon-onvoldoende-active.png") no-repeat center center;
}

.survey-item.selected .v-input--selection-controls.v-input .rating-icon.rating-slecht.rating-1 label.v-label {
  background: url("./assets/icons/rating/rating-icon-slecht-active.png") no-repeat center center;
}

.rating-icon {
  width: 117px;
  height: 115px;
  display: block;
  float: left;
  padding: 0 2px;
  position: relative;
}

.rating-icon img {
  width: 100%;
  height: auto;
}

.feedback-wrapper h2 {
  font-size: 20px;
  color: #111111;
  text-align: center;
  font-family: "TT Norms", sans-serif;
  font-weight: 500;
  margin: 0;
  padding: 10px 0;
}
.feedback-table{
  border-bottom: 1px solid #dedede;
  border-radius: 0!important;
}

.feedback-table table.v-table tbody td,
.feedback-table table.v-table tbody th {
  height: 32px;
  padding: 0 18px 0 0 !important;
}

.feedback-table table.v-table thead tr{
  height: 36px;
}

.feedback-table table.v-table thead td:not(:nth-child(1)), 
.feedback-table table.v-table tbody td:not(:nth-child(1)), 
.feedback-table table.v-table thead th:not(:nth-child(1)), 
.feedback-table table.v-table tbody th:not(:nth-child(1)), 
.feedback-table table.v-table thead td:first-child, 
.feedback-table table.v-table tbody td:first-child, 
.feedback-table table.v-table thead th:first-child, 
.feedback-table table.v-table tbody th:first-child{
  padding: 0 10px 0 0;
}

.queue-table table.v-table thead td:not(:nth-child(1)), 
.queue-table table.v-table tbody td:not(:nth-child(1)), 
.queue-table table.v-table thead th:not(:nth-child(1)), 
.queue-table table.v-table tbody th:not(:nth-child(1)), 
.queue-table table.v-table thead td:first-child, 
.queue-table table.v-table tbody td:first-child, 
.queue-table table.v-table thead th:first-child, 
.queue-table table.v-table tbody th:first-child{
  padding: 0 10px;
}


.branches-table table.v-table tbody td,
.branches-table table.v-table tbody th {
  height: 40px;
}

.branches-search-wrapper {
  padding: 0 15px;
}

.branches-table {
  border-bottom: 1px solid #e0e0e0;
}

.v-input--selection-controls.v-input .rating-icon label.v-label {
  width: 117px;
  max-width: 100%;
  height: 115px;
  display: block;
  float: left;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0;
  color: rgba(0, 0, 0, 0) !important;
}

.rating-icon .v-input--selection-controls__input {
  display: none !important;
}

.send-survey-button {
  font-family: "Sofia Pro", sans-serif;
  position: fixed;
  right: 30px;
  bottom: 30px;
  padding: 12px 55px 14px 15px;
  height: 45px;
  text-align: left;
  color: #ffffff;
  font-weight: 600;
  background: url("./assets/icons/next-button-white.svg") no-repeat center right 4px;
}

.send-survey-button .v-btn__content {
  font-weight: 600;
}

.send-survey-button:hover,
.send-survey-button:active,
.send-survey-button:focus {
  position: fixed;
  right: 30px;
  bottom: 30px;
}

.survey-sender {
  position: fixed;
  width: calc(100% - 40px);
  margin: 0;
  top: 0;
  left: 0;
  background-color: #fff;
  padding: 15px 20px;
  box-shadow: 0 9px 34px 0 rgba(139, 147, 166, 0.1);
}

.score-wrapper p {
  padding: 0;
}

.score-wrapper p.average-score {
  font-size: 48px;
  font-weight: 600;
}

.average-score-button {
  padding: 2px 0px 0 5px;
  display: inline-block;
  color: #fff;
}

@media only screen and (max-width: 680px) {
  .survey-wrapper {
    width: calc(100% - 20px);
    padding: 20px 15px 10px 15px;
    margin: 20px auto 100px auto;
  }
  .survey-logo-client {
    margin: 15px auto;
  }

  .survey-wrapper h2 {
    font-size: 22px;
    padding: 0;
  }
  .survey-wrapper p {
    font-size: 14px;
  }

  .survey-wrapper .v-radio {
    margin: 0 auto;
  }

  .survey-item .v-input--radio-group__input {
    display: block;
    width: 445px;
    margin: 0 auto;
  }

  .survey-item .v-input--selection-controls.v-input .rating-icon label.v-label {
    max-width: 100%;
    width: 85px;
    height: 75px;
  }

  .rating-icon {
    width: 89px;
    height: 75px;
    display: block;
    float: left;
    padding: 0 2px;
    position: relative;
  }

  .survey-item .v-input--selection-controls.v-input .rating-icon label.v-label {
    background-size: 80px !important;
  }
}

@media only screen and (max-width: 520px) {
  .survey-wrapper .survey-item h2 {
    font-size: 16px;
    padding: 5px 0 10px 0;
  }

  .survey-item .v-input--radio-group__input {
    display: block;
    width: 280px;
    margin: 0 auto;
  }

  .survey-wrapper .v-radio {
    margin: 0 auto;
  }

  .survey-wrapper .score-wrapper p.average-score {
    font-size: 36px;
    font-weight: 600;
  }

  .survey-item .v-input--selection-controls.v-input .rating-icon label.v-label {
    max-width: 100%;
    width: 56px;
    height: 50px;
  }

  .rating-icon {
    width: 56px;
    height: 50px;
    display: block;
    float: left;
    padding: 0 2px;
    position: relative;
  }

  .survey-item textarea {
    font-size: 14px;
  }

  .survey-item .v-input--selection-controls.v-input .rating-icon label.v-label {
    background-size: 45px !important;
  }

  .survey-item .v-input--selection-controls .v-input__slot {
    margin: 0 !important;
  }
}

.special-content-box ul.tabs-component-tabs {
  display: inline-block;
  list-style: none;
  height: 34px;
}

.special-content-box ul.tabs-component-tabs:after {
  display: block;
  content: "";
  clear: both;
}

.special-content-box ul.tabs-component-tabs li {
  float: left;
  display: block;
  margin: 0 10px 0 0;
}

.special-content-box ul.tabs-component-tabs li a {
  padding: 10px 16px 6px 16px;
  background-color: var(--v-menuhover-base);
  color: var(--v-text-base);
  font-size: 16px;
  text-decoration: none;
  display: block;
  border: 1px solid var(--v-menuborder-base);
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
}

.special-content-box ul.tabs-component-tabs li.is-active a {
  background-color: var(--v-menu-base);
  color: var(--v-text-base);
  font-weight: 500;
  border-bottom: 1px solid var(--v-menu-base);
}

.tabs-component-panels {
  margin: -1px 0 0 0;
  background-color: var(--v-menu-base);
  border: 1px solid var(--v-menuborder-base);
}

.edit-survey-page-text .editr--content {
  min-height: 100px;
}

.settings-form-label {
  padding: 15px 0 5px 0;
  display: block;
  font-size: 16px;
}

.survey-page-button {
  padding: 30px 0 0 0;
}

/* RESULTS SNACKBAR */

.results-snackbar {
  width: 100%;
  /* padding: 9px; */
  position: fixed;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.4);
  top: 0;
}

.results-snackbar.one {
  left: 0;
  z-index: 999;
}

.results-snackbar.one.small {
  width: calc(50% + 37px);
  right: 0;
  z-index: 998;
}

.results-snackbar.two {
  width: calc(50% - 37px);
  right: 0;
  z-index: 998;
}

.results-snackbar-close {
  height: 46px;
  width: 26px;
  background: url("./assets/icons/close-icon-white.svg") center center no-repeat;
  background-size: 14px;
  float: left;
}

.results-snackbar-close:hover {
  cursor: pointer;
}

.results-snackbar-selected {
  padding: 0 10px;
  float: left;
  height: 46px;
}

.selected-branches {
  width: 38px;
  height: 38px;
  line-height: 42px;
  color: #333;
  text-align: center;
  font-size: 16px;
  margin: 5px 0;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 46px;
  float: left;
}

.results-snackbar-selected p {
  float: left;
  font-size: 14px;
  color: #fff;
  padding: 0 10px;
  height: 46px;
  line-height: 46px;
}

.results-snackbar-input {
  float: left;
  width: 300px;
  height: 46px;
}

.results-select-gender {
  position: relative;
  width: 225px;
  height: 20px;
  border-radius: 20px;
  padding: 0 10px;
  line-height: 22px;
  background-color: rgba(255, 255, 255, 0.7);
}

.results-select-gender .v-input {
  font-size: 14px;
  overflow: hidden;
  border-radius: 20px;
  height: 20px;
  position: absolute;
  left: 20px;
  top: 1px;
}

.results-select-gender .v-text-field.v-text-field--solo .v-input__control {
  min-height: 20px;
}

.results-select-gender .v-select__selections,
.results-select-gender .v-select__slot {
  height: 20px;
}

.results-select-gender .v-select__selection {
  color: #5f1d9a !important;
}

.results-select-gender .v-input__slot {
  background-color: rgba(255, 255, 255, 0) !important;
}

.results-snackbar-button {
  float: right;
}

.results-snackbar-button button {
  display: inline-block;
  float: left;
  text-decoration: none;
  text-transform: uppercase;
  padding: 14px 15px;
  line-height: 15px;
  font-weight: 600;
  border-radius: 60px;
  background: #ffffff;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* .results-snackbar-button button:hover {
  background: #e5007d url("./assets/icons/button-results-white.svg") no-repeat center right 4px;
  color: #fff;
} */

.pre-icon .v-icon {
  position: absolute;
  top: 0;
  left: 8px;
  font-size: 16px;
  color: #5f1d9a !important;
  margin: 1px 0 0 0;
  height: 20px;
}

.results-select-month {
  position: relative;
  width: 225px;
  height: 20px;
  border-radius: 20px;
  padding: 0 10px;
  line-height: 22px;
  background-color: rgba(255, 255, 255, 0.7);
}

.datepicker {
  position: absolute;
  top: 0;
  width: 193px;
  left: 32px;
  cursor: pointer;
  color: #5f1d9a;
  z-index: 99;
}

.results-select-month .v-input__icon.v-input__icon--append {
  position: absolute;
  right: 12px;
  top: 0;
  z-index: 9;
}

.results-snackbar.small .results-snackbar-selected p {
    display: none;
  }
.results-snackbar.small .results-snackbar-close {
    width: 20px;
  }

.results-snackbar.small .results-snackbar-selected {
    padding: 0 5px;
  }

@media only screen and (max-width: 1023px) {
  .results-snackbar-selected p {
    display: none;
  }
  .results-snackbar-close {
    width: 20px;
  }

  .results-snackbar-selected {
    padding: 0 5px;
  }
}

.daterangepicker td.in-range {
  background-color: #eeecf6 !important;
}

.daterangepicker .ranges li.active {
  background-color: #5f1d9a !important;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #5f1d9a !important;
}

.daterangepicker .drp-buttons .btn.btn-primary.apply {
  background-color: #e5007d;
  color: #fff;
  border-radius: 5px;
  font-size: 14px;
  line-height: 12px;
  padding: 6px 20px 5px 20px;
}

.results-select-gender-wrapper {
  margin: 6px 0 0 0;
}

.tab-header-edit {
  float: right;
}

#page-wrapper.dual .results-snackbar.one {
  width: calc(37px + 50%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#page-wrapper.dual .overlay-one {
  position: fixed;
  width: calc(50% + 37px);
  left: 0;
  top: 0;
  display: block;
}

#page-wrapper.dual .overlay-two {
  position: fixed;
  width: calc(50% - 37px);
  right: 0 !important;
  top: 0;
  display: block;
}

.overlay-one {
  width: 100%;
  top: 0;
  left: 0;
}

.overlay-one,
.overlay-two {
  height: 100%;
  height: 100%;
  position: fixed;
  z-index: 99;
}

.barometer-loading {
  position: relative;
  width: 100%;
  padding: 350px 0 0 0;
}

.loading-icon-wrapper {
  position: absolute;
  width: 150px;
  height: 115px;
  top: 50%;
  left: 50%;
  margin: -75px 0 0 -75px;
}

.loading-icon {
  position: absolute;
  width: 100px;
  height: 100px;
  background: url("./assets/icons/loading-bars-colors.svg") no-repeat center center;
  background-size: 100px auto;
  left: 50%;
  margin-left: -50px;
}

.loading-text {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 14px;
  font-weight: 500;
  width: 150px;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
}

@media screen and (max-width: 1520px) {
  .results-snackbar-input {
    float: left;
    width: 220px;
    height: 46px;
  }

  .results-select-month-label,
  .results-select-gender-label {
    display: none;
  }
}

.pillar-card-title {
  background-color: #5f1d9a;
  position: relative;
}

.pillar-card-title h1,
.pillar-card-title h2,
.pillar-card-title h3,
.pillar-card-title h4,
.pillar-card-title p {
  color: #ffffff !important;
}

.pillar-card-title-close {
  width: 20px;
  height: 20px;
  background: url("./assets/icons/close-icon-white.svg") no-repeat center center;
  background-size: 14px;
  position: absolute;
  right: 10px;
  top: 20px;
}

.pillar-card-title-close:hover {
  cursor: pointer;
}

.header .handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
  width: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 5px;
  background: url("./assets/icons/drag-icon-white.svg") no-repeat center center;
  background-size: 20px;
  opacity: 0;
}

.header .edit {
  position: absolute;
  right: 10px;
  top: 0;
  opacity: 0;
}

.header:hover .handle,
.header:hover .edit {
  opacity: 1;
}

.grap {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
  text-align: center;
  /* width: 20px;
  height: 20px;
  background: url("./assets/icons/drag-icon-dark.svg") no-repeat center center;
  background-size: 20px;
  opacity: 0.5; */
}

.journey-heading-wrapper {
  padding: 10px 0;
}

.journey-heading-title {
  float: left;
}

.journey-heading-buttons {
  float: right;
}

.stages-wrapper {
  display: flex;
  flex-direction: row;
}

.stage-item {
  flex-grow: 1;
  flex-basis: 0;
  margin: 0 15px 0 0;
  overflow: hidden;
}

.secondary-button {
  border: 2px solid #e8e9ee;
  border-radius: 5px;
  color: #8b93a6;
  height: 46px;
  line-height: 46px;
  padding: 0 15px;
  font-size: 16px;
}

.secondary-button:hover {
  border: 2px solid #e5007d;
  background: #e5007d;
  box-shadow: 0 8px 21px 0 rgba(229, 0, 125, 0.3);
  color: #fff;
}

.secondary-button.active {
  border: 2px solid #e5007d;
  background: #e5007d;
  border-radius: 5px;
  color: #fff;
  height: 46px;
  box-shadow: 0 8px 21px 0 rgba(229, 0, 125, 0.3);
  line-height: 46px;
  padding: 0 15px;
  font-size: 16px;
}

.secondary-button.active:hover {
  border: 2px solid #5f1d9a;
  background: #5f1d9a;
  box-shadow: 0 8px 21px 0 rgba(229, 0, 125, 0.3);
  color: #fff;
}

.stage-item .header {
  padding: 0 10px;
  text-align: center;
  height: 50px;
  position: relative;
  overflow: hidden;
  line-height: 50px;
  font-size: 14px;
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  color: #fff;
}

.stage-item .header::before {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  content: "";
  width: 10px;
  height: 50px;
  background: url("./assets/icons/stage-arrow-before-medium.svg") no-repeat center center;
  background-size: 10px 50px;
}

.stage-item .header::after {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  content: "";
  width: 10px;
  height: 50px;
  background: url("./assets/icons/stage-arrow-after-medium.svg") no-repeat center center;
  background-size: 10px 50px;
}

.stage-item.legenda {
  max-width: 200px;
  margin-right: 10px;
}

.stage-item.legenda .header {
  text-align: left;
  background-color: #eee;
}

.stage-item.legenda .header::before,
.stage-item.legenda .header::after,
.stage-item.first .header::before,
.stage-item.last .header::after {
  border: 0;
  display: none;
}

.stage-desc-wrapper {
  padding: 10px 5px 5px 5px;
  color: #8b93a6;
  text-align: center;
  font-size: 14px;
}

.content-box.journey {
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  padding: 20px 0 0 0;
  margin: 0 0 20px 0;
}

.content-box.stage {
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  padding: 20px;
  margin: 0 0 20px 0;
}

.questions-stage {
  display: block;
  text-align: center;
  color: #fff;
  padding: 3px 5px;
}

.content-box-header {
  padding: 20px;
}

.content-box-header .title {
  float: left;
}

.content-box-header-buttons {
  float: right;
}

.form-active-switch {
  padding: 20px 0 0 0;
  margin: 0 0 0 30px;
}

.barometer-active-switch .v-input {
  margin: 0 !important;
}
.barometer-active-switch .v-input__slot {
  margin: 0 !important;
}

.social-item-wrapper .form-active-switch {
  padding: 10px 0 0 0;
  margin: 0 0 0 0;
}

.form-active-switch .v-input {
  margin: 0;
}

.form-active-switch .v-input__slot {
  margin: 0;
}

.response-loading {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #f6f7fb;
}

.response-loading-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
}


#custom-container {
  padding: 0 !important;
}

.api-select-wrapper {
  padding: 0 0 20px 0;
}
.api-select-wrapper .v-input,
.api-select-wrapper .v-input__slot {
  margin: 0;
}

.api-salonhub-logo {
  width: 100%;
  height: 70px;
  background: url(./assets/logos/salonhub-logo.svg) no-repeat left top;
  background-size: auto 45px;
  margin: 20px 0 0 0;
}

.api-drupal-logo {
  width: 100%;
  height: 70px;
  background: url(./assets/logos/drupal-logo.svg) no-repeat left top;
  background-size: auto 45px;
  margin: 20px 0 0 0;
}

.api-dyflexis-logo {
  width: 100%;
  height: 70px;
  background: url(./assets/logos/logo-dyflexis.svg) no-repeat left top;
  background-size: auto 45px;
  margin: 20px 0 0 0;
}

.api-salonhub-check-success,
.api-salonhub-check-warning {
  position: absolute;
  top: 10px;
  right: 10px;
}

.api-textfields {
  max-width: 400px;
}

.salonhub-branche-fields,
.drupal-branche-fields {
  background: var(--v-menu-base);
  padding: 15px;
  margin: 10px 0 10px 30px;
}

.salonhub-branche-fields-logo {
  width: 100%;
  height: 15px;
  background: url(./assets/logos/salonhub-logo.svg) no-repeat left top;
  background-size: auto 15px;
  margin: 0 0 10px 0;
}

.drupal-branche-fields-logo {
  width: 100%;
  height: 15px;
  background: url(./assets/logos/drupal-logo.svg) no-repeat left top;
  background-size: auto 15px;
}

.api-check-button {
  display: inline-block;
  float: left;
  text-decoration: none;
  padding: 14px 15px;
  height: 15px;
  height: 44px;
  line-height: 15px;
  color: #fff;
  background-color: #e5007d;
  font-weight: 600;
  border-radius: 5px;
  border: 2px solid #e5007d;
  margin: 10px 15px 0 0;
}

.api-check-button:hover {
  background: #ffffff;
  background-image: linear-gradient(-240deg, invalid gradient);
  box-shadow: 0 8px 21px 0 rgba(229, 0, 125, 0.3);
  border: none;
  padding: 16px 17px;
  color: #e5007d;
  cursor: pointer;
}
.hogans-alerts {
  padding: 0;
}
.hogans-alerts .v-alert {
  padding: 5px;
}

.tab-item {
  padding: 0 0 30px 0;
  border-bottom: 1px solid #e8e9ee;
  margin: 0 0 30px 0;
}

.tab-item.last {
  padding: 0;
  border-bottom: none;
  margin: 0;
}

.rating-view-wrapper p {
  font-size: 12px;
}

.tab-item-intro h3 {
  font-size: 18px;
  padding: 0 0 5px 0;
}

.tab-item-field {
  padding: 0 0 10px 0;
}

.tab-item-select {
  max-width: 400px;
  padding: 0 0 10px 0;
}

.smiley-example {
  width: 240px;
  height: 50px;
  background: url(./assets/smileys-example@2x.png) no-repeat left top;
  background-size: 240px auto;
}

.stars-example {
  width: 240px;
  height: 50px;
  background: url(./assets/stars-example@2x.png) no-repeat left top;
  background-size: 240px auto;
}

.hogans-modal-header {
  position: relative;
  padding: 20px 25px;
  background-color: #5f1d9a;
}

.hogans-modal-header h2,
.hogans-modal-header span {
  font-size: 18px;
  color: #ffffff;
}

.no-content {
  text-align: center;
  padding: 20px 0 60px 0;
}

.no-content param {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.4);
}

.select-color-field {
  padding: 15px 0 0 29px;
}

.select-color-field label {
  font-size: 16px;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s;
  color: rgba(0, 0, 0, 0.54);
  padding: 0 0 0 5px;
}

.custom-hint {
  font-size: 12px;
  line-height: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  padding: 0 0 8px 5px;
}

.journey-header-comp {
  font-size: 16px;
  padding: 5px;
}

.journey-header-type {
  padding: 0 0 0 5px;
}

.journey-header-type {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54) !important;
}

.journey-header-type .v-icon {
  font-size: 15px !important;
}



/* <div class="social-header clear">
  <div class="social-header-icon"></div>
  <h3>Facebook</h3>
  </div> */

.social-header-icon {
  width: 30px;
  height: 30px;
  float: left;
  margin: 0 5px 0 0;
}

.social-header-icon.facebook {
  background: url("./assets/social-icons/social-icon-facebook.svg") left center no-repeat;
  background-size: 28px auto;
}

.social-header-icon.instagram {
  background: url("./assets/social-icons/social-icon-instagram.png") left center no-repeat;
  background-size: 28px auto;
}

.social-header-icon.pinterest {
  background: url("./assets/social-icons/social-icon-pinterest.png") left center no-repeat;
  background-size: 28px auto;
}

.social-header-icon.googleplus {
  background: url("./assets/social-icons/social-icon-google-plus.png") left center no-repeat;
  background-size: 28px auto;
}

.social-header-icon.twitter {
  background: url("./assets/social-icons/social-icon-twitter.png") left center no-repeat;
  background-size: 28px auto;
}

.social-header h3 {
  float: left;
  padding: 4px;
}

.barometer-company-select {
  width: calc(50% - 10px);
  float: left;
  margin: 0 20px 0 0;
}

.barometer-branch-select {
  width: calc(50% - 10px);
  float: left;
}

.barometer-wrapper {
  padding: 10px;
}

.barometer-inner-wrapper {
  padding: 0 10px 10px 10px;
}

.barometer-inner-wrapper.border{
  border-right: 1px solid #eee;
}

.barometer-item-setting-wrapper {
  padding: 0 0 30px 0;
}

.barometer-canvas-wrapper {
  width: 220px;
  margin: 0 auto;
}
.branch-barometer-header {
  font-size: 20px;
}

.barometer-header h2 {
  font-family: "TT Norms", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: var(--v-text-base);
  text-align: center;
}

.barometer-inner-header h2 {
  font-family: "TT Norms", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: var(--v-text-base);
  text-align: center;
  padding-bottom: 16px;
}

.barometer-header h3 {
  font-family: "Sofia Pro", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: var(--v-text-base);
  text-align: center;
}

.barometer-header {
  padding: 0 0 20px 0;
}

.barometer-footer .barometer-rate {
  font-family: "Sofia Pro", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: var(--v-text-base);
  text-align: center;
}

.barometer-footer .barometer-description {
  font-family: "Sofia Pro", sans-serif;
  font-size: 14px;
  margin: 0 0 7px 0;
  color: var(--v-text-base);
  text-align: center;
}

.employee-barometers-wrapper h3.title {
  padding: 30px 0 15px 0;
  font-size: 18px;
}

.employee-barometer-wrapper {
  position: relative;
}

.employee-barometer-edit-button {
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0.3;
  z-index: 99;
  padding: 5px;
  cursor: pointer;
}

.employee-barometer-wrapper:hover > .employee-barometer-edit-button {
  display: block;
  cursor: pointer;
  opacity: 1;
}

.barometer-alert .v-alert {
  padding: 6px;
}
.barometer-alert .v-alert div {
  color: #fff !important;
}

.on-fire {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-bottom: -5px;
  background: url("./assets/icons/fire.svg") no-repeat center center;
  background-size: auto 25px;
}

.updateTimer {
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.5);
}

/* CONTENT HEADER MINIMUM */

.content-header-minimum .header-select-two-wrapper {
  float: left;
  width: 470px;
  margin: 0 15px 0 0;
}

.content-header-minimum .header-input {
  float: left;
  width: calc(100% - 500px);
}

.content-header-minimum .header-select-two-wrapper .header-company-select {
  width: 230px;
  margin: 0 15px 0 0;
  float: left;
}

.content-header-minimum .header-select-two-wrapper .header-branch-select {
  width: 225px;
  margin: 0;
  float: left;
}

.content-header-minimum.barometers .header-select-two-wrapper {
  float: left;
  width: calc(100% - 175px);
  margin: 0;
}

.content-header-minimum.barometers .header-select-two-wrapper .header-branch-select {
  width: calc(100% - 245px);
  margin: 0;
  float: left;
}

.content-header-minimum .header-select-two-wrapper .header-company-select .v-input,
.content-header-minimum .header-select-two-wrapper .header-branch-select .v-input {
  margin: 0;
  padding: 5px 0 0 0;
}

.content-header-minimum .header-input .header-button.photo {
  float: left;
}

.content-header-minimum .header-input .header-select-date {
  float: right;
}

.content-header-minimum .header-input .date-select-wrapper {
  padding: 0 0 5px 0;
}
.content-header-minimum .header-input .choose-date,
.content-header-minimum .header-input .arrow-prev,
.content-header-minimum .header-input .arrow-next {
  margin-bottom: 0;
}

.content-header-minimum.clients .header-company-select {
  width: 350px;
  float: left;
}

.content-header-minimum.clients .header-edit-search {
  float: right;
  width: 250px;
}

.date-select-text {
  text-align: center;
  font-weight: 400;
  text-transform: capitalize;
}

.no-salon-data {
  width: 350px;
  margin: 250px auto;
}

.no-salon-data p {
  text-align: center;
}

.legenda-wrapper {
  padding: 5px 0 10px 0;
}

.no-content p{
  padding: 15px 0;
}

.client-select-box{
  max-width: 100%;
}

.sendTimeLabel{
  font-size: 16px;
  line-height: 32px;
}
</style>
